import { fetchRubrics, saveSubscription } from '../../../api/user'
import { clone } from '../../../utils/object'

// initial state
const state = {
  rubrics: []
}

// getters
const getters = {
  rubrics: state => state.rubrics,
  subscribedIDs: state => {
    let checked = []
    for (let rubric of state.rubrics) {
      if (rubric.CHECKED) {
        checked.push(rubric.ID)
      }
    }
    return checked
  }
}

// actions
const actions = {
  async fetchRubrics ({commit, state}) {
    const data = await fetchRubrics()
    commit('setRubrics', {rubrics: data.rubrics})
  },
  async save ({commit, state, getters}) {
    await saveSubscription({
      IDs: getters.subscribedIDs
    })
  }
}

// mutations
const mutations = {
  setRubrics (state, {rubrics}) {
    state.rubrics = rubrics
  },
  setChecked (state, {id, value}) {
    let rubrics = clone(state.rubrics)

    console.log(rubrics)
    for (let rubric of rubrics) {
      if (rubric.ID === id) {
        rubric.CHECKED = value
      }
    }

    state.rubrics = rubrics
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/store/modules/subscribe.js